import prompthubEllipse from '../../../images/icons/prompthub-ellipse.svg';
import { Author } from '../../../components/types';

import { PromptResponse } from './types';

const DEFAULT_AUTHOR: Author = {
    uid: '0',
    name: 'Редакция',
    image: prompthubEllipse,
};

const getAuthorOrDefault = (author: Author): Author => {
    // Если автор это редакция (uid = 0), то дополняем данными
    if (author.uid === '0') {
        return { ...DEFAULT_AUTHOR, promptsCount: author.promptsCount };
    }

    return author;
};

export const transformPromptDtoToModel = (response: PromptResponse) => ({
    ...response,
    author: getAuthorOrDefault(response.author),
    createdAt: response.createdAt || '2025-10-30T12:00:00Z',
});
